<template>
  <div class="body">
    <div class="title">
      付费置顶配置
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"  class="dsadf">
            <span class="dsadf">首页</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>付费置顶配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
    </div>
    <vxe-table
      border
      show-overflow
      keep-source
      ref="xTable"
      max-height="750"
      class="mytable-scrollbar"
      align="center"
      :data="tableData"
      :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
      <vxe-table-column type="seq" width="60"></vxe-table-column>
      <vxe-table-column field="name" title="活动标题"></vxe-table-column>
      <vxe-table-column field="days" title="置顶天数"></vxe-table-column>
      <vxe-table-column field="price" title="价格"></vxe-table-column>
      <vxe-table-column title="操作" min-width="200">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <button   size="mini" @click="Editbianji(scope.row)" class="bianji">编辑</button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-modal  width="336" ref="jujue" height="202" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClosecc">
        <div class="titledd mbP">
          修改价格
        </div>
        <vxe-input v-model="remark" placeholder="请输入价格/元"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openjujue">
            确认
          </button>
          <button class="quxiao"  @click="routeClosecc">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { toppayedit, toppayList } from '@/api/xitongpeizhi'

export default {
  name: 'index',
  data () {
    return {
      tableData: [
      ],
      Query: {
        token: sessionStorage.getItem('token')
      },
      itemcc: {},
      remark: ''
    }
  },
  created () {
    this.xiangqing()
  },
  methods: {
    routeClosecc () {
      this.$refs.jujue.close()
    },
    Editbianji (row) {
      console.log('row', row)
      this.itemcc = row
      this.$refs.jujue.open()
    },
    openjujue () {
      const obj = {
        token: sessionStorage.getItem('token'),
        id: this.itemcc.id,
        price: this.remark
      }
      toppayedit(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.jujue.close()
          this.xiangqing()
        }
      })
    },
    xiangqing () {
      toppayList(this.Query).then(({ data: res }) => {
        console.log('resccccc', res)
        this.tableData = res.list
      })
    },
    chakanxiangqing (row) {
      // this.$store.commit('sethuodongID', row.id)
      this.$router.push('/huodongguanlichakanxiangqing?id=' + row.id)
    }
  }
}
</script>

<style scoped lang="less">
  .popchuangkou{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    .mbP{
      margin-bottom: 24px;
    }
    .dsff{
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
    }
    .titledd{
      margin-top: 22px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 500;
      text-align: left;
      color: #2e2e2e;
    }
    .einput{
      width: 253px;
      height: 44px;
      opacity: 1;
      background: #fbfbfb;
      border-radius: 5px;
    }
    .bobox{
      margin-top: 43px;
      display:flex;
      flex-direction: row;
      align-items: center;
    }
    .queren{
      width: 95px;
      height: 36px;
      opacity: 1;
      background: linear-gradient(135deg,#3d9aff, #3380f2);
      border-radius: 2px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      letter-spacing: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      margin-right: 12px;
    }
    .quxiao{
      width: 95px;
      height: 36px;
      opacity: 1;
      background: rgba(61,154,255,0.10);
      border-radius: 2px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: left;
      color: #3d9aff;
      letter-spacing: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
    }
  }
.bianji{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #3d9aff;
  letter-spacing: 0px;
  background: white;
}
.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }

  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      margin-right: 150px;
    }
    .right{
      margin-top: 27px;
    }
  }
}
</style>
